<template>
  <div dir="rtl">
    <div dir="ltr" class="is-flex is-align-items-center is-justify-content-space-between" style="margin-bottom: 30px;">
      <checkbox v-model="showArchive" @input="init">Show Archive</checkbox>
      <a @click="deleteSelectedCheckboxes()" class="button is-info is-danger">Delete selected Checkboxes</a>
      <a @click="toggleCheckboxesSelection()" class="button is-info">{{ is_all_checkboxes_selected ? 'Unselect' : 'Select' }} All Checkboxes</a>
    </div>
    <div v-if="is_loading" class="loading"></div>
    <div v-if="hidden_files.length" style="margin-top: 20px;">
      <p class="bold">hidden</p>
      <SingleFile v-for="file in hiddenFiles" v-model="file.is_checked" @input="onFileToggled" :file="file" :applicant="applicant" @profileChecked="profileChecked"
                   :is_checked="file.is_checked" :key="file.name" @refresh="init" :is_archive="showArchive" :show_checkbox="oneFileRestriction">>
      </SingleFile>
    </div>
    <div>
      <p v-if="getNewFiles().length > 0" class="bold">קבצים גלויים</p>
      <SingleFile v-for="file in getNewFiles()" v-model="file.is_checked" @input="onFileToggled" :file="file" :applicant="applicant" @profileChecked="profileChecked"
                   :is_checked="file.is_checked" :key="file.name" @refresh="init" :is_archive="showArchive" :show_checkbox="oneFileRestriction">>
      </SingleFile>
    </div>
    <div style="margin-top: 20px;">
      <p class="bold">קבצים שנבחרו</p>
      <p v-if="getCheckedFiles().length == 0">אין קבצים שנבחרו</p>
      <SingleFile v-for="file in getCheckedFiles()" v-model="file.is_checked" @input="onFileToggled" :file="file" :applicant="applicant" @profileChecked="profileChecked"
                   :is_checked="file.is_checked" :key="file.name" @refresh="init" :is_archive="showArchive" />
    </div>
    <div style="margin-top: 20px;">
      <p class="bold">קבצים שנדחו</p>
      <SingleFile v-for="file in getRejectedFiles()" v-model="file.is_checked" @input="onFileToggled" :file="file" :applicant="applicant" @profileChecked="profileChecked"
                   :is_checked="file.is_checked" :key="file.name" @refresh="init" :is_archive="showArchive" :show_checkbox="oneFileRestriction">>
      </SingleFile>
    </div>
    <div class="mt-4 is-flex is-justify-content-flex-end">
      <a @click="uploadFile" class="button is-info">Upload File</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import SingleFile from '@/components/SingleFile'
import Checkbox from '@/components/Checkbox'
import FileHelper from '@/custom/classes/file_helper.js'
export default {
  name: 'Files',
  components: {
    SingleFile,
    Checkbox
  },
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    isSendOneFile: {
      type: Boolean
    },
    isSendLite: {
      type: Boolean,
      default: false
    },
    sendMode: {
      type: String,
      default: 'normal'
    },
    defaultCvType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      file_helper: new FileHelper(),
      is_loading: true,
      applicant: this.payload.applicant_data,
      profile_file_name: `פרופיל מועמד - ${this.$settings.get({ path: 'display_app_name' })} - ${this.payload.applicant_data.full_name}.pdf`,
      files: [],
      hidden_files: [],
      approved_files: [],
      rejected_files: [],
      showArchive: false,
      is_all_checkboxes_selected: false
    }
  },
  computed: {
    oneFileRestriction () {
      if (!this.isSendOneFile) return true
      return this.files.filter(f => f.is_checked).length < 1
    },
    hiddenFiles () {
      return this.hidden_files.filter(file => !file.is_checked)
    }
  },
  watch: {
    sendMode (newMode) {
      // Refresh files when send mode changes
      console.log('Files component - sendMode changed to:', newMode)
      this.init()
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.is_loading = true
      this.files = []
      // hidden_files must be reset too: init() re-runs on upload refresh, and
      // without this the HR files accumulate duplicates that then surface in
      // getCheckedFiles()/getCheckedFileNames().
      this.hidden_files = []
      let files_request = this.$network_utils.getFiles({
        resource_id: this.applicant.resource_id,
        show_archive: this.showArchive,
        full_env_name: this.$settings.get({ path: 'full_env_name' })
      })
      let approved_files_request = this.$network_utils.getResourceText({
        current_type: 'Applicant',
        current_resource_id: this.applicant.resource_id,
        designator: 'approved_files'
      })
      let rejected_files_request = this.$network_utils.getResourceText({
        current_type: 'Applicant',
        current_resource_id: this.applicant.resource_id,
        designator: 'rejected_files'
      })
      let requests = [files_request, approved_files_request, rejected_files_request]
      this.$caller.axios.all(requests).then(response => {
        this.is_loading = false
        let files = response[0] == undefined ? [] : response[0]
        files.unshift({ name: this.profile_file_name })
        let approved_files = response[1]
        let rejected_files = response[2]
        this.approved_files = typeof approved_files == 'string' ? [] : approved_files.content.split(',')
        this.rejected_files = typeof rejected_files == 'string' ? [] : rejected_files.content.split(',')
        // Filter files based on send mode
        console.log('Files component - filtering files for sendMode:', this.sendMode)
        console.log('Files component - all files before filtering:', files.map(f => f.name))

        switch (this.sendMode) {
          case 'super_lite':
            const superLiteFiles = this.getSuperLiteFiles(files)
            console.log('Files component - super_lite filtered files:', superLiteFiles.map(f => f.name))
            this.setFiles(superLiteFiles)
            break
          case 'lite':
            const liteFiles = this.getLiteFiles(files)
            console.log('Files component - lite filtered files:', liteFiles.map(f => f.name))
            this.setFiles(liteFiles)
            break
          case 'normal':
          default:
            console.log('Files component - normal mode, using all files')
            this.setFiles(files)
            break
        }
        // Pre-check files matching the configured default CV type, if any.
        // `defaultCvType` is empty unless the parent modal has CV_PATTERN_UI_ENABLED,
        // so with the flag off the selection behaves exactly as before.
        if (this.defaultCvType) {
          this.selectFilesByCvType(this.defaultCvType)
        }
        this.emitNoDefaultFile()
      })
    },
    // A manual tick always wins (E-13): selectFilesByCvType only ever runs from
    // init(), so this handler just re-evaluates the missing-file band.
    onFileToggled () {
      this.emitNoDefaultFile()
    },
    // Send mode -> required CV variant. Identical map to Cv::FileTypeClassifier.
    getCvTypeForMode (mode) {
      return this.file_helper.getCvTypeForMode(mode)
    },
    // True when a required CV type is configured and NO checked file satisfies
    // it. A warning band — never a block (FE-6).
    //
    // F-8. The `checked.length == 0` early return made the band unreachable in
    // its PRIMARY case: when the candidate has no file of the required type at
    // all, `selectFilesByCvType` ticks nothing, so zero files are checked — and
    // the one screen that had to warn her stayed silent. Zero checked files is
    // the strongest possible instance of "nothing checked satisfies the type",
    // not an exemption from it.
    noDefaultFile () {
      if (!this.defaultCvType) return false
      const all = [...this.files, ...this.hidden_files]
      const checked = all.filter(file => file.is_checked)
      return !checked.some(file => this.satisfiesDefaultCvType(file))
    },
    // THE predicate. Both the band and the auto-tick read it, so "the band is
    // quiet" and "a satisfying file is ticked" can no longer disagree.
    //
    // getSuperLiteFiles admits the generated `פרופיל מועמד` PDF alongside
    // cv_<env>.pdf, and it is a perfectly valid super_lite selection — but
    // FileHelper.getCvType classifies it 'regular', so a recruiter who ticked
    // ONLY the profile file was shown "no matching CV file" on a screen where
    // the file she needed was already checked. The band must agree with the
    // list it is complaining about, and the tick must agree with the band.
    satisfiesCvType (file, cvType) {
      if (!cvType) return false
      if (this.file_helper.getCvType(file.name) === cvType) return true
      if (cvType !== 'super_hide') return false
      return file.name.toLowerCase().includes('פרופיל מועמד')
    },
    satisfiesDefaultCvType (file) {
      return this.satisfiesCvType(file, this.defaultCvType)
    },
    emitNoDefaultFile () {
      this.$emit('noDefaultFile', this.noDefaultFile() ? this.defaultCvType : null)
    },
    profileChecked (value) {
      this.$emit('profileChecked', value)
    },
    setFiles (files_response) {
      let defaultFile = null
      for (let i = 0; i < files_response.length; i++) {
        let file = files_response[i]
        if (this.isSendOneFile) {
          this.files.push(file)
          continue
        }
        if (file.name.toLowerCase().includes('hr')) {
          if (!defaultFile || new Date(file.uploaded_at) > new Date(defaultFile.uploaded_at)) {
            defaultFile = file
          }
          this.hidden_files.push(file)
          continue
        }
        if (this.approved_files.includes(file.name)) {
          file.is_checked = true
        }
        if (this.rejected_files.includes(file.name)) {
          file.is_checked = false
        }
        this.files.push(file)
      }
      // Only set is_checked if defaultFile exists
      if (defaultFile) {
        defaultFile.is_checked = true
      }
    },
    uploadFile () {
      this.create({ designator: 'upload-file-modal', component_name: 'UploadFileForm', applicant: this.applicant, modal_title: 'העלאת קבצים', refresh: this.init })
    },
    getLiteFiles (files) {
      // For lite mode, include profile file and HR files
      return files.filter(file => {
        const fileName = file.name.toLowerCase()
        return fileName.includes('hr') || fileName.includes('פרופיל מועמד')
      })
    },
    getSuperLiteFiles (files) {
      return files.filter(file => {
        // Delegate to the shared classifier instead of re-declaring the
        // cv_<env>.pdf pattern locally — the local copy had drifted and was
        // missing the 'bullrun' tenant, so its generated CV never showed up
        // in super_lite mode. Also include profile file for super lite mode.
        return this.file_helper.getCvType(file.name) === 'super_hide' ||
          file.name.toLowerCase().includes('פרופיל מועמד')
      })
    },
    getNewFiles () {
      return this.files.filter(file => file.is_checked == undefined)
    },
    getCheckedFiles () {
      // De-duplicated by name (FE-4): a file must never be sent twice because
      // it ended up in both lists.
      const seen = {}
      const checked = []
      const push = file => {
        if (!file.is_checked || seen[file.name]) return
        seen[file.name] = true
        checked.push(file)
      }
      this.files.forEach(push)
      this.hidden_files.forEach(push)
      return checked
    },
    getCheckedFileNames () {
      return this.getCheckedFiles().map(file => file.name)
    },
    // Auto-check files matching the chosen CV type. For 'regular' only the
    // single most recent CV is checked (the generated profile file is excluded)
    // — a candidate can have many regular CVs.
    //
    // ADDITIVE (FE-5): a file the recruiter explicitly approved stays checked
    // and a file she explicitly rejected stays unchecked; the type-driven
    // default is only applied on top of the files she has not decided about.
    // The previous version reassigned `is_checked` for EVERY file and silently
    // discarded those decisions.
    //
    // Bug A (CEO directive R-5e, intentional behavior change): under
    // `normal` + defaultCvType 'regular' the newest REGULAR CV is ticked and
    // the newest HR file — which setFiles() auto-ticks — is unticked.
    selectFilesByCvType (cvType) {
      const allFiles = [...this.files, ...this.hidden_files]
      // Same predicate as the band (satisfiesCvType), so a file the band counts
      // as satisfying the type is a file this ticks. The one carve-out is the
      // generated profile PDF under 'regular': it is not one of the candidate's
      // own CVs, and auto-ticking it would send the profile instead of a CV.
      const isType = file => {
        if (!this.satisfiesCvType(file, cvType)) return false
        if (cvType === 'regular' && file.name === this.profile_file_name) return false
        return true
      }

      let latestRegular = null
      if (cvType === 'regular') {
        allFiles.filter(isType).forEach(file => {
          if (!latestRegular ||
              new Date(file.uploaded_at) > new Date(latestRegular.uploaded_at)) {
            latestRegular = file
          }
        })
      }

      allFiles.forEach(file => {
        if (this.approved_files.includes(file.name)) {
          file.is_checked = true
          return
        }
        if (this.rejected_files.includes(file.name)) {
          file.is_checked = false
          return
        }
        file.is_checked = cvType === 'regular' ? file === latestRegular : isType(file)
      })
      this.$forceUpdate()
    },
    getRejectedFiles () {
      return this.files.filter(file => file.is_checked == false)
    },
    getRejectedFileNames () {
      return this.getRejectedFiles().map(file => file.name)
    },
    toggleCheckboxesSelection () {
      this.is_all_checkboxes_selected = !this.is_all_checkboxes_selected
      this.files = this.files.map(file => {
        file.is_checked = this.is_all_checkboxes_selected
        return file
      })
      this.$forceUpdate()
    },
    async deleteSelectedCheckboxes () {
      if (!confirm('בטוח למחוק את כל הקבצים שנבחרו?')) {
        return
      }
      const files = this.getCheckedFiles()
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        await this.$network_utils.deleteFile({
          file_name: file.name,
          resource_id: this.applicant.resource_id,
          resource_type: 'Applicant',
          first_name: this.applicant.first_name,
          last_name: this.applicant.last_name,
          show_archive: this.showArchive
        })
      }
      this.is_loading = true
      this.init()
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
